﻿import ActivePage from "../activePage";

export default class PatWorkflowPage extends ActivePage {
    constructor() {
        super();
    }

    initialize = (screen, id) => {
        this.editableGrids = [            
            { name: "patWorkflowActionGrid", filter: { parentId: id }, afterSubmit: this.updateRecordStamps }           
        ];

        this.tabsLoaded = [];
        this.tabChangeSetListener();       
    }
   
    tabChangeSetListener = () => {
        const self = this;
        $('#patWorkflow-tab a').on('click',
            (e)=> {
                e.preventDefault();
                const tab = e.target.id;
                if (this.tabsLoaded.indexOf(tab) === -1) {
                    this.tabsLoaded.push(tab);
                    this.loadTabContent(tab);
                }
            });

        $(document).ready(function() {
            const actionsGrid = $("#patWorkflowActionGrid");
            actionsGrid.on("click", ".workFlowActionLink", (e) => {
                e.stopPropagation();

                let url = $(e.target).data("url");
                const row = $(e.target).closest("tr");
                const dataItem = actionsGrid.data("kendoGrid").dataItem(row);
                const linkUrl = url.replace("actualValue", dataItem.ActionValueId);
                pageHelper.openLink(linkUrl, false);
            });
        });
    }    

    loadTabContent(tab) {
        switch (tab) {  

        case "":
            break;
        }
    } 

    getParentTStamp = () => {
        const container = $(`#${this.detailContentContainer}`);
        const tStamp = container.find("input[name='tStamp']");
        return tStamp.val();
    }

    triggerTypeSearchOnChange = (e) => {
        console.log(e);
        var selectedItem = e.sender.value();
        if (selectedItem) {
            var triggerValue = $("#TriggerTypeId_patWorkflowSearch").data("kendoComboBox");
            triggerValue.dataSource.read({ triggerType: selectedItem });
        }
    }
    
    //----------------------------------------------------------------- trigger, trigger value
    getTriggerType() {
        return {
            triggerType: $("#Trigger").data("kendoDropDownList").value()
        };
    }

    triggerValueOnChange = (e) => {
        var selectedItem = e.sender.dataItem();
        if (selectedItem) {
            $("#TriggerValueId").val(selectedItem.Value);
        }
    }

    triggerTypeOnChange = (e) => {
        var selectedItem = e.sender.dataItem();
        $("#TriggerTypeId").val(selectedItem.Value);

        var triggerValue = $("#TriggerValue").data("kendoDropDownList");
        triggerValue.dataSource.read({ triggerType: selectedItem.Value });
        triggerValue.value("0");
        triggerValue.trigger("change");
    }


    //------------------------------------------------------------------ action, action value
    actionTypeOnChange = (e) => {
        if (e.item) {
            const row = $(`#${e.sender.element[0].id}`).closest("tr");
            const grid = $("#patWorkflowActionGrid").data("kendoGrid");
            const dataItem = grid.dataItem(row);
            dataItem.ActionTypeId = e.dataItem["Value"];

            dataItem.ActionValueId = -1;
            $(row).find(".action-value-field").html("");
        }
    }

    actionValueOnChange = (e) => {
        if (e.item) {
            const row = $(`#${e.sender.element[0].id}`).closest("tr");
            const grid = $("#patWorkflowActionGrid").data("kendoGrid");
            const dataItem = grid.dataItem(row);
            dataItem.ActionValueId = e.dataItem["Value"];
        }
    }

    getActionType = (e) => {
        var grid = $("#patWorkflowActionGrid").data("kendoGrid");
        var selectedData = grid.dataItem(grid.select());

        return {
            actionTypeId: selectedData.ActionTypeId,
            request: e
        };
    }
}
